// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-core-pages-page-template-tsx" + "-" + "8dde06c84f9ba36646f1" + ".js";
};